import { css } from 'styled-components';
import makeThemedComponent from '../../utils/makeThemedComponent';
var defaultStyles = css(["display:flex;flex-direction:row;flex-wrap:wrap;"]);
/**
 * Renders a `div` element usable as a container for a flexbox grid.
 *
 * @public
 * @author Connor Taylor
 */

var Grid = makeThemedComponent({
  themeKey: "Grid",
  component: "div",
  defaultStyles: defaultStyles
});
export { defaultStyles };
/** @component */

export default Grid;